module.exports = __webpack_public_path__ + "static/media/score-wt.6f0d41d1.svg";